module.exports = __webpack_public_path__ + "img/file-post.6e7631a6.svg";